import { SWReactIcons } from "@similarweb/icons";
import { EPrimaryItemType } from "@similarweb/ui-components";

import type { ISubSectionItem } from "app/components/sidebar3/types";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { EPrimarySideBar3IdType, EPrimarySideBar3StateType } from "app/reducers/_reducers/PrimarySidebar3Reducer";
import { openHooksModalV5 } from "app/services/ModalService";
import { allTrackers } from "app/services/track/track";

const createSearchAppsListItem = (isSIAppLeadGenEnabled: boolean, hasAppsPermission: boolean): ISubSectionItem => {
    return {
        title: "primary.sidebar.salesIntelligence.searchForApps",
        icon: "sidebar3-search-apps",
        state: EPrimarySideBar3StateType.SIFindApps,
        id: EPrimarySideBar3IdType.SIFindApps,
        itemType: EPrimaryItemType.GroupItem,
        onClick(state) {
            if (!isSIAppLeadGenEnabled && !hasAppsPermission) {
                openHooksModalV5("AppLeadGenerator");
            } else {
                allTrackers.dispatchTrackEvent("side menu", "click", "find apps");
                proNavigator.go(state);
            }
        },
        upsellBadgeComponent: !isSIAppLeadGenEnabled && !hasAppsPermission && (
            <SWReactIcons
                size="xs"
                iconName={"sparkles"}
            />
        ),
    };
};

export default createSearchAppsListItem;
